import { 
  GET_ALL_IN_BRANCH,
  GET_MONTHLY_INVENTORY_DATA,
  LOAD_MORE_MONTHLY_INVENTORY_DATA

} from '../actions/types';

const monthlyinventory_data = {
  branchitems: [],
  data: [],
  origData:[],
  dataCount:0,
  dataNext:null,
  dataPrevious:null,
  editModalOpen: false,
  previewModalOpen: false,
  item:[],
  currentProps:null,


};





// eslint-disable-next-line import/no-anonymous-default-export
export default (state = monthlyinventory_data, action) => {
  var dataArray;
  switch (action.type) {   
    case GET_ALL_IN_BRANCH:            
      return {  
        ...state,
        branchitems:action.payload   
      };


    case GET_MONTHLY_INVENTORY_DATA:         
      var  newdata = action.payload.dataArray
      var  lastVisible = action.payload.lastVisible
      return {  
        origData:newdata,
        data: newdata,
        dataCount:newdata.length,
        lastVisible:lastVisible,
        currentProps:action.payload.currentProps
      };

    case LOAD_MORE_MONTHLY_INVENTORY_DATA:         
      var  newdata = action.payload.dataArray
      var  lastVisible = action.payload.lastVisible
      return {  
        ...state,
        origData:newdata.concat(state.origData),
        data: newdata.concat(state.data),
        dataCount:newdata.concat(state.origData).length,
        lastVisible:lastVisible,
     
      };
   
    default:
      return state;
  }
};
